export default __webpack_public_path__ + "static/404-hero-212ce123c652c62db337efca8b7b5cce.jpg";